const routes = [
  {
    path: '/',
    name: 'ServiceMain',
    component: () => import('@/layout/Service'),
    redirect: { name: 'OpenMarketLayout'},
    children: [
      {
        path: 'open-market',
        name: 'OpenMarketLayout',
        component: () => import('@/layout/OpenMarket'),
        redirect: { name: 'OpenMarket'},
        children: [
          {
            path: '',
            name: 'OpenMarket',
            component: () => import('@/components/openMarket')
          },
          {
            path: 'existing-registration',
            name: 'ExistingRegistration',
            component: () => import('@/components/openMarket/existingRegistration')
          },
//          {
//            path: 'step1',
//            name: 'RegistrationStep1',
//            component: () => import('@/components/openMarket/step1')
//          },
          {
            path: 'step1',
            name: 'RegistrationStep1',
            component: () => import('@/components/openMarket/step1_privacy') //오픈마켓 privacy 연동 신규
          },
          {
            path: 'step2',
            name: 'RegistrationStep2',
            component: () => import('@/components/openMarket/step2')
          },
          {
            path: 'step3',
            name: 'RegistrationStep3',
            component: () => import('@/components/openMarket/step3'),
          },
          {
            path: 'step4',
            name: 'RegistrationStep4',
            component: () => import('@/components/openMarket/step4')
          },
          {
            path: 'step3/identify-verification',
            name: 'IdentityVerificationSection',
            component: () => import('@/components/openMarket/step3/IdentityVerificationSection')
          },
          {
            path: 'step3/identify-verification',
            name: 'IdentityVerificationSection2',
            component: () => import('@/components/openMarket/step3/IdentityVerificationSection2')
          },
          //[ST][CSR:RITM2694040] 안면인증 1차 시범서비스 - 외국인 안면인증 안하게 처리
          {
            path: 'step3/identify-verification',
            name: 'IdentityVerificationSectionNonFace',
            component: () => import('@/components/openMarket/step3/IdentityVerificationSectionNonFace')
          },
          //[ED][CSR:RITM2694040] 안면인증 1차 시범서비스 - 외국인 안면인증 안하게 처리
        ]
      },
      {
        path: 'open-market/terms',
        name: 'OpenMarketTerms',
        component: () => import('@/components/openMarket/Terms')
      },
      {
        path: 'after-activation',
        name: 'AfterActivationLayout',
        component: () => import('@/layout/AfterActivation'),
        redirect: { name: 'AfterActivation' },
        children: [
          {
            path: '',
            name: 'AfterActivation',
            component: () => import('@/components/afterActivation')
          },
          {
            path: 'auth-popup',
            name: 'AfterActivationAuthPopup',
            component: () => import('@/components/afterActivation/AuthPopup')
          },
          {
            path: 'auth-result',
            name: 'AfterActivationAuthResult',
            component: () => import('@/components/afterActivation/AuthResult')
          }
        ]
      },
      {
        path: 'connected-car',
        name: 'ConnectedCarLayout',
        component: () => import('@/layout/ConnectedCar'),
        redirect: { name: 'ConnectedCar' },
        children: [
//          {
//            path: '',
//            name: 'ConnectedCar',
//            component: () => import('@/components/connectedCar')
//          },
          {
            path: '',
            name: 'ConnectedCar',
            component: () => import('@/components/connectedCar/step1_privacy') //privacy센터 변경
          }, 
          {
            path: 'step2',
            name: 'ConnectedCarStep2',
            component: () => import('@/components/connectedCar/step2')
          },
          {
            path: 'step3',
            name: 'ConnectedCarStep3',
            component: () => import('@/components/connectedCar/step3')
          },
        ]
      },
      {
        path: 'samsung',
        name: 'SamSungLayout',
        component: () => import('@/layout/SamSung'),
        redirect: { name: 'SamSung'},
        children: [
          {
            path: '',
            name: 'SamSung',
            component: () => import('@/components/samSung')
          },
          {
            path: 'existing-registration',
            name: 'ExistingRegistration_samsung',
            component: () => import('@/components/samSung/existingRegistration')
          },
//          {
//            path: 'step1',
//            name: 'RegistrationStep1_samsung',
//            component: () => import('@/components/samSung/step1')
//          },
          {
            path: 'step1',
            name: 'RegistrationStep1_samsung',
            component: () => import('@/components/samSung/step1_privacy') //privacy센터 변경
          },
          {
            path: 'step2',
            name: 'RegistrationStep2_samsung',
            component: () => import('@/components/samSung/step2')
          },
          {
            path: 'step3',
            name: 'RegistrationStep3_samsung',
            component: () => import('@/components/samSung/step3'),
          },
          {
            path: 'step4',
            name: 'RegistrationStep4_samsung',
            component: () => import('@/components/samSung/step4')
          },
          {
            path: 'step3/identify-verification',
            name: 'IdentityVerificationSection_samsung',
            component: () => import('@/components/samSung/step3/IdentityVerificationSection')
          },
          {
            path: 'step3/identify-verification',
            name: 'IdentityVerificationSection2_samsung',
            component: () => import('@/components/samSung/step3/IdentityVerificationSection2')
          },
          //[ST][CSR:RITM2694040] 안면인증 1차 시범서비스 - 외국인 안면인증 안하게 처리
          {
            path: 'step3/identify-verification',
            name: 'IdentityVerificationSectionNonFace_samsung',
            component: () => import('@/components/samSung/step3/IdentityVerificationSectionNonFace')
          },
          //[ED][CSR:RITM2694040] 안면인증 1차 시범서비스 - 외국인 안면인증 안하게 처리
        ]
      },
      // {
      //   path: 'onsaleHomeTest/terms',
      //   name: 'onsaleHomeTestTerms',
      //   component: () => import('@/components/onsaleHome/Terms')
      // },
      // {
      //   path: 'onsaleHomeTest',
      //   name: 'OnsaleHomeLayout',
      //   component: () => import('@/layout/OnsaleHome'),
      //   children: [
      //     {
      //       path: '',
      //       name: 'OnsaleHome',
      //       component: () => import('@/components/onsaleHome')
      //     },
      //     {
      //       path: 'step1',
      //       name: 'OnsaleHomeStep1',
      //       component: () => import('@/components/onsaleHome/step1')
      //     },
      //     {
      //       path: 'step2',
      //       name: 'OnsaleHomeStep2',
      //       component: () => import('@/components/onsaleHome/step2')
      //     },
      //     {
      //       path: 'auth-popup',
      //       name: 'OnsaleHomeAuthPopup',
      //       component: () => import('@/components/onsaleHome/popup/AuthPopup')
      //     }
      //   ]
      // },
      {
        path: 'connected-car/terms',
        name: 'ConnectedCarTerms',
        component: () => import('@/components/connectedCar/Terms')
      },
      {
        path: 'auth-popup',
        name: 'AuthPopupLayout',
        component: () => import('@/layout/AuthPopupLayout'),
        children: [
          {
            path: 'ipin-auth-popup',
            name: 'CallIpinAuthPop',
            component: () => import('@/components/popup/CallIpinAuthPop')
          },
          {
            path: 'ipin-auth-result',
            name: 'ResultIpinAuthPop',
            component: () => import('@/components/popup/ResultIpinAuthPop')
          },
          {
            path: 'normal-auth-popup',
            name: 'CallNormalAuthPop',
            component: () => import('@/components/popup/CallNormalAuthPop')
          },
          {
            path: 'normal-auth-result',
            name: 'ResultNormalAuthPop',
            component: () => import('@/components/popup/ResultNormalAuthPop')
          },
          {
            path: 'kmc-auth-popup',
            name: 'CallKmcAuthPop',
            component: () => import('@/components/popup/CallKmcAuthPop')
          },
          {
            path: 'kmc-auth-result',
            name: 'ResultKmcAuthPop',
            component: () => import('@/components/popup/ResultKmcAuthPop')
          },
          {
            path: 'kcb-auth-popup',
            name: 'CallKcbAuthPop',
            component: () => import('@/components/popup/CallKcbAuthPop')
          },
          {
            path: 'kcb-auth-result',
            name: 'ResultKcbAuthPop',
            component: () => import('@/components/popup/ResultKcbAuthPop')
          },
          {// [C20230630_99755_4599755]공인인증 오픈마켓사용 2023.07.11 장희정 추가
            path: 'kmc-publ-auth-popup',
            name: 'CallKmcPublAuthPop',
            component: () => import('@/components/popup/CallKmcPublAuthPop')
          },
          {// [C20230630_99755_4599755]공인인증 오픈마켓사용 2023.07.11 장희정 추가
            path: 'kmc-publ-auth-result',
            name: 'ResultKmcPublAuthPop',
            component: () => import('@/components/popup/ResultKmcPublAuthPop')
          },
          {
            path: 'inicis-auth-popup',
            name: 'CallInicislAuthPop',
            component: () => import('@/components/popup/CallInicisAuthPop')
          },
          {
            path: 'inicis-auth-result',
            name: 'ResultInicisAuthPop',
            component: () => import('@/components/popup/ResultInicisAuthPop')
          }
        ]
      }
    ]
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/components/ErrorPage')
  },
  {
    path: '/jsp/sqr/rqst/common/popup_cellphone_auth_kmc.jsp',
    name: 'AfterActivationRedirectPage',
    component: () => import('@/components/afterActivation/RedirectPage')
  },
  {
    path: '/CounselApplicationNewFormCmd.uplus',
    name: 'SimpleCounselRedirectPage',
    component: () => import('@/components/simpleCounsel/RedirectPage')
  },
  {
    path: '/SusAppFormUserTypeCmd.uplus',
    name: 'OpenMarketRedirectPage',
    component: () => import('@/components/openMarket/RedirectPage')
  },
  {
    path: '/IndexCmd.uplus',
    name: 'OpenMarketExistingRegistrationRedirectPage',
    component: () => import('@/components/openMarket/existingRegistration/RedirectPage')
  },
  {
    path: '/CarAppFormUserTypeCmd.uplus',
    name: 'ConnectedCarRedirectPage',
    component: () => import('@/components/connectedCar/RedirectPage')
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/components/NotFound')
  },
  // {
  //   path: '/test',
  //   name: 'test',
  //   component: () => import('@/components/test/test')
  // },

  // {
  //   path: '/',
  //   name: 'OpenMarket',
  //   component: () => import('@/components/openMarket')
  // },
  // {
  //   path: '/existing-registration',
  //   name: 'ExistingRegistration',
  //   component: () => import('@/components/openMarket/existingRegistration')
  // },
  // {
  //   path: '/step1',
  //   name: 'RegistrationStep1',
  //   component: () => import('@/components/openMarket/step1')
  // },
  // {
  //   path: '/step2',
  //   name: 'RegistrationStep2',
  //   component: () => import('@/components/openMarket/step2')
  // },
  // {
  //   path: '/step3',
  //   name: 'RegistrationStep3',
  //   component: () => import('@/components/openMarket/step3'),
  // },
  // {
  //   path: '/step4',
  //   name: 'RegistrationStep4',
  //   component: () => import('@/components/openMarket/step4')
  // },
  // {
  //   path: '/step3/identify-verification',
  //   name: 'IdentityVerificationSection',
  //   component: () => import('@/components/openMarket/step3/IdentityVerificationSection')
  // },

  
]

export { routes }
  